(function() {
  'use strict';

  /**
   * Find ALL Klaviyo-injected BIS trigger buttons anywhere in the document.
   * Klaviyo BIS elements have BOTH needsclick AND kl-private-reset-css-Xuajs1 classes.
   * Returns an array of buttons (may be empty).
   */
  function getAllKlaviyoInjectedBISTriggers() {
    var found = [];
    var seen = new Set();
    var selectors = [
      'button.needsclick.kl-private-reset-css-Xuajs1',
      'button.needsClick.kl-private-reset-css-Xuajs1',
      'button[data-klaviyo-id]',
      '#klaviyo-bis-button-container button:not([data-vicis-bis-fallback])'
    ];

    for (var i = 0; i < selectors.length; i++) {
      var els = document.querySelectorAll(selectors[i]);
      for (var j = 0; j < els.length; j++) {
        if (!els[j].hasAttribute('data-vicis-bis-fallback') && !seen.has(els[j])) {
          seen.add(els[j]);
          found.push(els[j]);
        }
      }
    }
    return found;
  }

  /**
   * Parse the variant ID from the URL query string (?variant=XXXXX).
   */
  function getVariantIdFromURL() {
    var match = window.location.search.match(/[?&]variant=(\d+)/);
    return match ? match[1] : null;
  }

  /**
   * Restyle Klaviyo's injected BIS button to match the site theme.
   * Also move it from Klaviyo's container into our theme container.
   */
  function restyleKlaviyoButton(klaviyoBtn, container, isStickyForm) {
    if (!klaviyoBtn || !container) return;

    // Move the Klaviyo button into our theme container if not already there
    if (klaviyoBtn.closest('[id*="klaviyo-bis-button"]') !== container) {
      container.appendChild(klaviyoBtn);
    }

    // Apply theme classes and styling
    klaviyoBtn.classList.add('product-form__add-button', 'button', 'button--primary');
    if (!isStickyForm) klaviyoBtn.classList.add('button--full');
    klaviyoBtn.setAttribute('data-vicis-bis-restyled', '1');

    // Force theme styles
    klaviyoBtn.style.cssText = [
      'display: block !important',
      'visibility: visible !important',
      'opacity: 1 !important',
      'position: static !important',
      'width: 100% !important',
      'min-width: 140px !important',
      'background-color: rgb(var(--primary-button-background)) !important',
      'color: rgb(var(--primary-button-text-color)) !important',
      'font-family: var(--text-font-family) !important',
      'font-size: 18px !important',
      'letter-spacing: .1em !important',
      'line-height: 40px !important',
      'text-transform: uppercase !important',
      'background-image: none !important',
      'border: none !important',
      'border-radius: 0 !important',
      'cursor: pointer !important',
      'padding: 0 20px !important',
      'clip: auto !important',
      'overflow: visible !important',
      'height: auto !important'
    ].join('; ');

    // Hide the Klaviyo wrapper div (the parent that has unpredictable styling)
    var klWrapper = klaviyoBtn.parentElement;
    if (klWrapper && klWrapper !== container && klWrapper.classList && klWrapper.classList.contains('kl-private-reset-css-Xuajs1')) {
      // Move button out of wrapper, into container directly
      container.appendChild(klaviyoBtn);
      klWrapper.style.cssText = 'display: none !important;';
    }

    // Hide Klaviyo's own container if it exists separately
    var klContainer = document.getElementById('klaviyo-bis-button-container');
    if (klContainer && klContainer !== container) {
      klContainer.style.cssText = 'display: none !important;';
    }
  }

  /**
   * Ensure a fallback BIS button exists when Klaviyo hasn't injected one.
   * Uses the Liquid-rendered button (data-vicis-bis-fallback) or creates one.
   */
  function ensureFallbackButton(container, productId, variantId) {
    if (!container) return null;

    var isStickyForm = container.id && container.id.includes('sticky');
    var fallbackBtn = container.querySelector('[data-vicis-bis-fallback]');

    if (!fallbackBtn) {
      fallbackBtn = document.createElement('button');
      fallbackBtn.type = 'button';
      fallbackBtn.className = 'klaviyo-bis-trigger product-form__add-button button button--primary' + (isStickyForm ? '' : ' button--full');
      fallbackBtn.setAttribute('data-vicis-bis-fallback', '1');
      fallbackBtn.setAttribute('data-product-id', productId);
      fallbackBtn.setAttribute('data-variant-id', variantId);
      fallbackBtn.textContent = 'Notify me when back in stock';
      container.appendChild(fallbackBtn);
    }

    // Update IDs
    fallbackBtn.setAttribute('data-product-id', productId);
    fallbackBtn.setAttribute('data-variant-id', variantId);
    container.setAttribute('data-variant-id', variantId);

    // Force show
    container.style.cssText = 'display: block !important; visibility: visible !important; opacity: 1 !important;';
    fallbackBtn.style.cssText = 'display: block !important; visibility: visible !important; opacity: 1 !important;';

    // Attach Klaviyo API click handler (once) — only used when Klaviyo doesn't inject a button
    if (!fallbackBtn.hasAttribute('data-klaviyo-bis-proxied')) {
      fallbackBtn.setAttribute('data-klaviyo-bis-proxied', '1');
      fallbackBtn.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();

        var vid = this.getAttribute('data-variant-id');
        var pid = this.getAttribute('data-product-id');

        // Try to find and click Klaviyo's injected trigger (it may have been injected after init)
        var allBtns = getAllKlaviyoInjectedBISTriggers();
        var klaviyoBtn = allBtns.length > 0 ? allBtns[0] : null;
        if (klaviyoBtn) {
          klaviyoBtn.click();
          return;
        }

        // Fallback: Use Klaviyo JS API directly
        if (window.klaviyo && typeof window.klaviyo.open === 'function') {
          window.klaviyo.open({
            name: 'back-in-stock',
            product: { id: pid, variant_id: vid }
          });
        } else if (window._learnq && window._learnq.push) {
          window._learnq.push(['track', 'Back in Stock Click', {
            ProductID: pid,
            VariantID: vid
          }]);
        }
      });
    }

    return fallbackBtn;
  }

  /**
   * Main logic: show BIS button when Add to Cart is disabled (sold out).
   * If Klaviyo has injected its trigger, restyle it to match the theme.
   * If not, show our fallback button.
   */
  function showKlaviyoButton() {
    try {
      var addToCart = document.getElementById('AddToCart');
      var stickyAddToCart = document.getElementById('StickyAddToCart');
      var containers = document.querySelectorAll('[id*="klaviyo-bis-button"]');

      // Determine which form is active (main vs sticky)
      var stickyFormEl = document.querySelector('.product-sticky-form');
      var stickyActive = !!(stickyFormEl && !stickyFormEl.hasAttribute('hidden'));
      var activeType = stickyActive ? 'sticky' : 'main';

      // If no BIS containers exist yet, create them dynamically
      if (containers.length === 0) {
        var mainPaymentContainer = document.querySelector('.product-form__payment-container');
        var stickyPaymentContainer = document.querySelector('.product-sticky-form__payment-container');

        if (mainPaymentContainer && addToCart && (addToCart.disabled || addToCart.classList.contains('button--ternary'))) {
          var form = mainPaymentContainer.closest('form');
          var productIdInput = form ? form.querySelector('input[name="product_id"]') : null;
          var productId = productIdInput ? productIdInput.value : '';

          var newContainer = document.createElement('div');
          newContainer.id = 'klaviyo-bis-button-' + (productId || 'main');
          newContainer.className = 'klaviyo-bis-button-container';
          newContainer.setAttribute('data-product-id', productId);
          mainPaymentContainer.appendChild(newContainer);
        }

        if (stickyPaymentContainer && stickyAddToCart && (stickyAddToCart.disabled || stickyAddToCart.classList.contains('button--ternary'))) {
          var form2 = stickyPaymentContainer.closest('form') || document.querySelector('form[id*="product-form"]');
          var productIdInput2 = form2 ? form2.querySelector('input[name="product_id"]') : null;
          var productId2 = productIdInput2 ? productIdInput2.value : '';

          var newContainer2 = document.createElement('div');
          newContainer2.id = 'klaviyo-bis-button-sticky-' + (productId2 || 'main');
          newContainer2.className = 'klaviyo-bis-button-container';
          newContainer2.setAttribute('data-product-id', productId2);
          stickyPaymentContainer.appendChild(newContainer2);
        }

        containers = document.querySelectorAll('[id*="klaviyo-bis-button"]');
      }

      // Find ALL Klaviyo-injected BIS triggers
      var allKlaviyoBtns = getAllKlaviyoInjectedBISTriggers();

      // URL variant override
      var urlVariantId = getVariantIdFromURL();

      // Track whether we've already placed a Klaviyo button in a container
      var klaviyoBtnUsed = false;

      containers.forEach(function(container) {
        // Skip Klaviyo's own injected container (no product-ID suffix)
        if (container.id === 'klaviyo-bis-button-container') return;

        var isMain = container.id.includes('klaviyo-bis-button-') && !container.id.includes('sticky');
        var isSticky = container.id.includes('sticky');

        // Hard-hide the non-active container
        if (activeType === 'sticky' && isMain) {
          container.style.cssText = 'display: none !important; visibility: hidden !important; opacity: 0 !important;';
          return;
        }
        if (activeType === 'main' && isSticky) {
          container.style.cssText = 'display: none !important; visibility: hidden !important; opacity: 0 !important;';
          return;
        }

        var button = isMain ? addToCart : (isSticky ? stickyAddToCart : null);
        if (!button) return;

        // Sold-out detection: ignore the loader transition (aria-busy)
        var isBusy = button.getAttribute('aria-busy') === 'true';
        var isDisabled = (button.disabled || button.classList.contains('button--ternary')) && !isBusy;

        if (isDisabled) {
          var form = button.closest('form');
          var productIdInput = form ? form.querySelector('input[name="product_id"]') : null;
          var variantIdInput = form ? form.querySelector('input[name="id"]') : null;

          var productId = container.getAttribute('data-product-id') ||
                          (productIdInput ? productIdInput.value : '') ||
                          container.id.replace('klaviyo-bis-button-', '').replace('-sticky', '');

          var variantId = urlVariantId ||
                          container.getAttribute('data-variant-id') ||
                          (variantIdInput ? variantIdInput.value : '');

          // Check if there's already a restyled Klaviyo button in this container
          var existingRestyled = container.querySelector('[data-vicis-bis-restyled]');

          if (existingRestyled) {
            // Already have a restyled button — just ensure only one is visible
            existingRestyled.style.setProperty('display', 'block', 'important');
            // Hide any extra Klaviyo buttons that ended up in this container
            var allRestyled = container.querySelectorAll('[data-vicis-bis-restyled]');
            for (var ri = 1; ri < allRestyled.length; ri++) {
              allRestyled[ri].style.cssText = 'display: none !important;';
            }
            klaviyoBtnUsed = true;
          } else if (allKlaviyoBtns.length > 0 && !klaviyoBtnUsed) {
            // Restyle the first Klaviyo button and move it into this container
            restyleKlaviyoButton(allKlaviyoBtns[0], container, isSticky);
            klaviyoBtnUsed = true;
          } else if (allKlaviyoBtns.length === 0) {
            // No Klaviyo buttons at all — use our fallback
            ensureFallbackButton(container, productId, variantId);
          }

          // Hide the Liquid fallback when a Klaviyo button is present
          var fallback = container.querySelector('[data-vicis-bis-fallback]');
          if (fallback && klaviyoBtnUsed) {
            fallback.style.cssText = 'display: none !important;';
          }

          container.style.cssText = 'display: block !important; visibility: visible !important; opacity: 1 !important;';

          // Hide Add to Cart
          button.style.setProperty('display', 'none', 'important');
        } else {
          // In-stock: hide BIS container, restore Add to Cart
          container.style.setProperty('display', 'none', 'important');
          button.style.removeProperty('display');
        }
      });

      // Hide any remaining Klaviyo buttons that weren't placed in a container
      // but skip buttons inside Klaviyo's own popup/form overlay
      for (var ki = 0; ki < allKlaviyoBtns.length; ki++) {
        if (!allKlaviyoBtns[ki].hasAttribute('data-vicis-bis-restyled') &&
            !allKlaviyoBtns[ki].closest('.klaviyo-form, [class*="klaviyo-form"], [data-testid*="klaviyo-form"]')) {
          allKlaviyoBtns[ki].style.cssText = 'display: none !important;';
        }
      }
    } catch(e) {
      // Silently handle errors
    }
  }

  // --- Initialization ---

  function init() {
    showKlaviyoButton();
    setTimeout(showKlaviyoButton, 100);
    setTimeout(showKlaviyoButton, 500);
    setTimeout(showKlaviyoButton, 1000);
    setTimeout(showKlaviyoButton, 2000);
    setTimeout(showKlaviyoButton, 3000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Watch for variant changes
  document.addEventListener('variant:changed', function() {
    setTimeout(showKlaviyoButton, 100);
  });

  // MutationObserver on Add to Cart buttons (disabled/class changes)
  var addToCartObserver = new MutationObserver(function() {
    showKlaviyoButton();
  });

  setTimeout(function() {
    var addToCart = document.getElementById('AddToCart');
    var stickyAddToCart = document.getElementById('StickyAddToCart');
    if (addToCart) addToCartObserver.observe(addToCart, { attributes: true, attributeFilter: ['disabled', 'class'] });
    if (stickyAddToCart) addToCartObserver.observe(stickyAddToCart, { attributes: true, attributeFilter: ['disabled', 'class'] });
  }, 500);

  // Re-run BIS arbitration when sticky form toggles (scroll in/out)
  setTimeout(function() {
    var stickyFormEl = document.querySelector('.product-sticky-form');
    if (!stickyFormEl) return;

    var stickyArbObserver = new MutationObserver(function() {
      showKlaviyoButton();
    });

    stickyArbObserver.observe(stickyFormEl, {
      attributes: true,
      attributeFilter: ['hidden', 'class', 'style']
    });
  }, 500);

  // MutationObserver on the document body to detect Klaviyo injection
  setTimeout(function() {
    var bisObserver = new MutationObserver(function(mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var addedNodes = mutations[i].addedNodes;
        for (var j = 0; j < addedNodes.length; j++) {
          var node = addedNodes[j];
          if (node.nodeType !== 1) continue;

          var isKlaviyoNode = (
            ((node.tagName === 'BUTTON' || node.tagName === 'DIV') &&
              node.classList.contains('kl-private-reset-css-Xuajs1')
            ) ||
            (node.hasAttribute && node.hasAttribute('data-klaviyo-id')) ||
            (node.id && node.id === 'klaviyo-bis-button-container') ||
            (node.querySelector && node.querySelector(
              '.kl-private-reset-css-Xuajs1, [data-klaviyo-id], #klaviyo-bis-button-container'
            ))
          );

          if (isKlaviyoNode) {
            showKlaviyoButton();
            return;
          }
        }
      }
    });

    bisObserver.observe(document.body, { childList: true, subtree: true });
  }, 200);

  // --- Combo-box color swatch helpers (unchanged) ---

  function updateComboBoxColorSwatches() {
    var stickyForm = document.querySelector('.product-sticky-form');
    if (!stickyForm) return;

    var comboBoxOptions = stickyForm.querySelectorAll('.combo-box__option-item');
    comboBoxOptions.forEach(function(option) {
      var colorSwatch = option.querySelector('.combo-box__color-swatch');
      if (!colorSwatch) return;

      var isDisabled = option.classList.contains('is-disabled') ||
                      option.hasAttribute('disabled') ||
                      option.hasAttribute('hidden') ||
                      option.getAttribute('aria-disabled') === 'true';

      if (isDisabled) {
        colorSwatch.classList.add('is-disabled');
      } else {
        colorSwatch.classList.remove('is-disabled');
      }
    });

    var selectButtons = stickyForm.querySelectorAll('.select[aria-controls*="combo-box"]');
    selectButtons.forEach(function(selectButton) {
      var selectedValueSpan = selectButton.querySelector('.select__selected-value');
      if (selectedValueSpan) {
        var colorSwatch = selectedValueSpan.querySelector('.select__color-swatch');
        if (colorSwatch) {
          var comboBoxId = selectButton.getAttribute('aria-controls');
          if (comboBoxId) {
            var comboBox = document.getElementById(comboBoxId);
            if (comboBox) {
              var selectedValue = selectedValueSpan.textContent.trim();
              var optionItems = comboBox.querySelectorAll('.combo-box__option-item');
              optionItems.forEach(function(option) {
                if (option.textContent.trim() === selectedValue ||
                    option.getAttribute('value') === selectedValue) {
                  var isDisabled = option.classList.contains('is-disabled') ||
                                  option.hasAttribute('disabled') ||
                                  option.hasAttribute('hidden') ||
                                  option.getAttribute('aria-disabled') === 'true';

                  if (isDisabled) {
                    colorSwatch.classList.add('is-disabled');
                  } else {
                    colorSwatch.classList.remove('is-disabled');
                  }
                }
              });
            }
          }
        }
      }
    });
  }

  function initComboBoxObservers() {
    var stickyForm = document.querySelector('.product-sticky-form');
    if (!stickyForm) return;

    setTimeout(updateComboBoxColorSwatches, 500);

    var observer = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        if (mutation.type === 'attributes' &&
            (mutation.attributeName === 'class' || mutation.attributeName === 'aria-disabled' || mutation.attributeName === 'disabled' || mutation.attributeName === 'hidden')) {
          updateComboBoxColorSwatches();
        }
      });
    });

    var comboBoxOptions = stickyForm.querySelectorAll('.combo-box__option-item');
    comboBoxOptions.forEach(function(option) {
      observer.observe(option, {
        attributes: true,
        attributeFilter: ['class', 'aria-disabled', 'disabled', 'hidden']
      });
    });

    var comboBoxes = stickyForm.querySelectorAll('.combo-box');
    comboBoxes.forEach(function(comboBox) {
      observer.observe(comboBox, {
        childList: true,
        subtree: true
      });
    });

    var comboBoxToggleObserver = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        if (mutation.type === 'attributes' && mutation.attributeName === 'aria-expanded') {
          var toggleButton = mutation.target;
          if (toggleButton.getAttribute('aria-expanded') === 'false' &&
              toggleButton.closest('.product-sticky-form')) {
            setTimeout(updateComboBoxColorSwatches, 100);
          }
        }
      });
    });

    var toggleButtons = stickyForm.querySelectorAll('[is="toggle-button"][aria-controls*="combo-box"]');
    toggleButtons.forEach(function(button) {
      comboBoxToggleObserver.observe(button, {
        attributes: true,
        attributeFilter: ['aria-expanded']
      });
    });
  }

  document.addEventListener('click', function(e) {
    if (e.target.closest('.combo-box__option-item') ||
        e.target.closest('.combo-box') ||
        e.target.closest('[is="toggle-button"][aria-controls*="combo-box"]') ||
        e.target.closest('.combo-box__close-button')) {
      setTimeout(updateComboBoxColorSwatches, 100);
    }
  });

  document.addEventListener('change', function(e) {
    if (e.target.tagName === 'SELECT' && e.target.closest('.product-sticky-form')) {
      setTimeout(updateComboBoxColorSwatches, 150);
    }
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initComboBoxObservers);
  } else {
    initComboBoxObservers();
  }

})();
